module.exports = __webpack_public_path__ + "img/overview.5438c6a1.png";